import Context from './index';
import React, { useEffect, useState } from 'react';

const LearningProvider = (props) => {

    const [learningData, setLearningData] = useState([]);

    return (
        <Context.Provider
            value={{
                ...props,
                learningData,
            }}
        >
            {props.children}
        </Context.Provider>
    );
};
export default LearningProvider;